import AppRoutes from "./routes";
import React, { useEffect } from "react";
import TagManager from "react-gtm-module";

const App: React.FC = () => {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-TXSXZF6L",
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  return <AppRoutes />;
};

export default App;
